<template>
<v-app>

  <router-view />
</v-app>
</template>
<script>
export default {
  beforeCreate() {
    
    console.log(this.$axios.defaults.headers)
  },
  mounted(){
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
